import { render, staticRenderFns } from "./AntUnixToLocalTime.vue?vue&type=template&id=64fd4cea&scoped=true"
import script from "./AntUnixToLocalTime.vue?vue&type=script&lang=js"
export * from "./AntUnixToLocalTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fd4cea",
  null
  
)

export default component.exports